import { Button } from "../../components/ui/Button";
import { Dialog } from "../../components/ui/Dialog";
import { formatDateTime } from "../../lib/format";
import type { Draft } from "./drafts";

export function RecoveryPrompt({
  draft,
  serverVersion,
  onRestore,
  onDiscard,
}: {
  draft: Draft | null;
  serverVersion: number;
  onRestore: () => void;
  onDiscard: () => void;
}) {
  return (
    <Dialog
      open={draft !== null}
      onClose={onDiscard}
      dismissible={false}
      title="Restore unsaved changes?"
      footer={
        <>
          <Button onClick={onDiscard}>Discard them</Button>
          <Button variant="primary" onClick={onRestore}>
            Restore changes
          </Button>
        </>
      }
    >
      {draft ? (
        <div className="grid gap-2 text-ink-2">
          <p>
            This device kept changes to this document from {formatDateTime(draft.savedAt)} that never reached the
            server.
          </p>
          {draft.baseVersion < serverVersion ? (
            <p className="text-orange-ink">
              The document has been saved by someone since then. After restoring, you choose how to combine the two
              versions.
            </p>
          ) : null}
        </div>
      ) : null}
    </Dialog>
  );
}
